export const MODULE_CATEGORIES = ['Main', 'Workforce', 'Site Tools', 'Procurement', 'Reports', 'System'];
/** Module keys that cannot be disabled — they're load-bearing for every login. */
export const CORE_MODULES = ['dashboard', 'settings'];
export const MODULES = [
    { key: 'dashboard', label: 'Dashboard', icon: '⬡', active: true, nav: true, category: 'Main' },
    { key: 'projects', label: 'Projects', icon: '◈', active: true, nav: true, category: 'Main' },
    { key: 'customers', label: 'Customers', icon: '◎', active: true, nav: true, category: 'Main' },
    { key: 'contacts', label: 'Contacts', icon: '◉', active: true, nav: true, category: 'Main' },
    { key: 'workers', label: 'Workers', icon: '◐', active: true, nav: true, category: 'Workforce' },
    { key: 'training', label: 'Training', icon: '◫', active: true, nav: true, category: 'Workforce' },
    { key: 'vacancy', label: 'Vacancies', icon: '⚑', active: true, nav: true, category: 'Workforce' },
    { key: 'broadcasts', label: 'Broadcasts', icon: '📢', active: true, nav: true, category: 'Workforce' },
    { key: 'availsignals', label: 'Availability Signals', icon: '🟢', active: true, nav: true, category: 'Workforce' },
    { key: 'deploylog', label: 'Deploy Records', icon: '📋', active: true, nav: true, category: 'Workforce' },
    { key: 'bulkdeploy', label: 'Bulk Deploy', icon: '🚀', active: true, nav: true, category: 'Workforce' },
    { key: 'qrscan', label: 'QR Scanner', icon: '⬛', active: true, nav: true, category: 'Site Tools' },
    { key: 'signin', label: 'Sign In/Out', icon: '✅', active: true, nav: true, category: 'Site Tools' },
    { key: 'docsign', label: 'Document Sign', icon: '✍', active: true, nav: true, category: 'Site Tools' },
    { key: 'suppliers', label: 'Suppliers', icon: '◑', active: true, nav: true, category: 'Procurement' },
    { key: 'compliance', label: 'Compliance Report', icon: '📊', active: true, nav: true, category: 'Reports' },
    { key: 'calendar', label: 'Availability', icon: '🗓', active: true, nav: true, category: 'Reports' },
    { key: 'timesheet', label: 'Timesheets', icon: '⏱', active: true, nav: true, category: 'Reports' },
    { key: 'scheduledreports', label: 'Scheduled Reports', icon: '📨', active: true, nav: true, category: 'Reports' },
    { key: 'settings', label: 'Settings', icon: '⚙', active: true, nav: true, category: 'System' },
];
export const PAGE_TITLES = {
    dashboard: 'CLS Command Centre',
    projects: 'Projects',
    customers: 'Customers',
    contacts: 'Contacts',
    workers: 'Workforce Manager',
    training: 'Training & Compliance',
    vacancy: 'Vacancy Matcher',
    broadcasts: 'Broadcasts',
    availsignals: 'Availability Signals',
    deploylog: 'Deployment Records',
    suppliers: 'Suppliers',
    settings: 'Settings',
    qrscan: 'QR Scanner',
    signin: 'Sign In / Out',
    docsign: 'Document Signing',
    compliance: 'Compliance Report',
    calendar: 'Worker Availability Calendar',
    timesheet: 'Timesheets',
    bulkdeploy: 'Bulk Deployment',
    scheduledreports: 'Scheduled Reports',
};
//# sourceMappingURL=modules.js.map